import React from "react";
import "./Badge.css";

const Badge = ({ status }) => {
  const getStatusClass = () => {
    switch (status.toLowerCase()) {
      case "pending":
      case "disabled":
        return "badge-pending";
      case "in_progress":
        return "badge-in-progress";
      case "active":
        return "badge-completed";
      case "completed":
        return "badge-completed";
      case "canceled":
      case "deleted":
        return "badge-canceled";
      case "inactive":
        return "badge-canceled";
      default:
        return "badge-default";
    }
  };

  console.log("Status:", status);

  const formatStatus = (status) => {
    if (!status) return "";

    const statusMap = {
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      canceled: "Canceled",
      active: "Active",
      inactive: "Inactive",
      deleted: "Deleted",
    };

    return statusMap[status.toLowerCase()] || status;
  };

  return (
    <span className={`badge ${getStatusClass()}`}>{formatStatus(status)}</span>
  );
};

export default Badge;
